import React, {useState, useEffect, useRef} from 'react';
import './TimerComponent.scss';
//import exp from 'node:constants';

// type TimeData = {
//     days: number;
//     hours: number;
//     minutes: number;
//     seconds: number;
//     expired: boolean;
// };

// type PrevTimeData = {
//     prevDays: number;
//     prevHours: number;
//     prevMinutes: number;
//     prevSeconds: number;
// }

const TimerComponent = () => {

    // const [timeLeft, setTimeLeft] = useState<TimeData>({
    //     days: 0,
    //     hours: 0,
    //     minutes: 0,
    //     seconds: 0,
    //     expired: false,
    // });

    // const [prevDates, setPrevDates] = useState<PrevTimeData>({
    //     prevDays: 0,
    //     prevHours: 0,
    //     prevMinutes: 0,
    //     prevSeconds: 0,
    // });

    // const [alreadyInAnim, setAlreadyInAnim] = useState(false);

    const daysRef = useRef<HTMLDivElement | null>(null);
    const hoursRef = useRef<HTMLDivElement | null>(null);
    const minutesRef = useRef<HTMLDivElement | null>(null);
    const secondsRef = useRef<HTMLDivElement | null>(null);

    const expired = useRef(false);
    const [isExpiredState, setIsExpiredState] = useState(false);

    // const [displaySeconds, setDisplaySeconds] = useState(0);
    // const [displayPrevSeconds, setDisplayPrevSeconds] = useState(0);
    
    useEffect(() => {
        const targetDate = new Date("May 24, 2026 17:00:00");
      
        const updateTimer = () => {
            const now = new Date();
            const difference = targetDate.getTime() - now.getTime();
            const _expired = difference < 0;
        
            const totalSeconds = Math.floor(difference / 1000);
            const totalMinutes = Math.floor(totalSeconds / 60);
            const totalHours = Math.floor(totalMinutes / 60);
            const days = Math.floor(totalHours / 24);
        
            const hours = totalHours % 24;
            const minutes = totalMinutes % 60;
            const seconds = totalSeconds % 60;

            const secondsDiv = secondsRef.current;
            const minutesDiv = minutesRef.current;
            const hoursDiv = hoursRef.current;
            const daysDiv = daysRef.current;
            
            // secondsDiv?.classList.remove('animate');
            //void secondsDiv?.offsetWidth;
            // secondsDiv?.classList.add('animate');

            expired.current = _expired;
            if (_expired && !isExpiredState) {
                setIsExpiredState(true);
            }
            // setTimeLeft({
            //     days: expired ? 0 : days,
            //     hours: expired ? 0 : hours,
            //     minutes: expired ? 0 : minutes,
            //     seconds: expired ? 0 : seconds,
            //     expired,
            // });

            //Kalkulacija prethodnog dana, komplikovano
            let _prevDays = days - 1;
            let _prevHours = hours - 1;
            _prevHours = _prevHours < 0 ? 23 : _prevHours;
            let _prevMinutes = minutes - 1;
            _prevMinutes = _prevMinutes < 0 ? 59 : _prevMinutes;
            let _prevSeconds = seconds - 1;
            _prevSeconds = _prevSeconds < 0 ? 59 : _prevSeconds;

            // setPrevDates({
            //     prevDays: _prevDays,
            //     prevHours: _prevHours,
            //     prevMinutes: _prevMinutes,
            //     prevSeconds: _prevSeconds,
            // });

            //Postavka flipa
            //Ok izgleda da mora ovako, to nisam hteo ali tako stoje stvari.
            // Ruzan i zastareo js nacin, ali sta da se radi.
            //Inace ovaj kod je sa github-a, prepravljen za react, nadam se da je open source...
            if (secondsDiv) {
                // if (!expired.current) secondsDiv.classList.add("animate");
                // else secondsDiv.classList.remove("animate");
                secondsDiv.innerHTML = 
                `<div class="countnum-backtop">${expired.current ? '00' : format(_prevSeconds)}</div>
                <div class="countnum-backbottom">${expired.current ? '00' : format(_prevSeconds)}</div>
                <div class="countnum-top">${expired.current ? '00' : format(seconds)}</div>
                <div class="countnum-bottom">${expired.current ? '00' : format(seconds)}</div>
                <div class="countnum-line"></div>`;
            }

            if (minutesDiv) {
                if (seconds === 0) minutesDiv.classList.add('animate');
                else minutesDiv.classList.remove('animate');

                minutesDiv.innerHTML = 
                `<div class="countnum-backtop">${expired.current ? '00' : format(_prevMinutes)}</div>
                <div class="countnum-backbottom">${expired.current ? '00' : format(_prevMinutes)}</div>
                <div class="countnum-top">${expired.current ? '00' : format(minutes)}</div>
                <div class="countnum-bottom">${expired.current ? '00' : format(minutes)}</div>
                <div class="countnum-line"></div>`;
            }

            if (hoursDiv) {
                if (seconds === 0 && minutes === 0) hoursDiv.classList.add('animate');
                else hoursDiv.classList.remove('animate');

                hoursDiv.innerHTML = 
                `<div class="countnum-backtop">${expired.current ? '00' : format(_prevHours)}</div>
                <div class="countnum-backbottom">${expired.current ? '00' : format(_prevHours)}</div>
                <div class="countnum-top">${expired.current ? '00' : format(hours)}</div>
                <div class="countnum-bottom">${expired.current ? '00' : format(hours)}</div>
                <div class="countnum-line"></div>`;
            }

            if (daysDiv) {
                if (seconds === 0 && minutes === 0 && hours === 0) daysDiv.classList.add('animate');
                else daysDiv.classList.remove('animate');

                daysDiv.innerHTML = 
                `<div class="countnum-backtop">${expired.current ? '00' : format(_prevDays)}</div>
                <div class="countnum-backbottom">${expired.current ? '00' : format(_prevDays)}</div>
                <div class="countnum-top">${expired.current ? '00' : format(days)}</div>
                <div class="countnum-bottom">${expired.current ? '00' : format(days)}</div>
                <div class="countnum-line"></div>`;
            }



            if (expired.current && secondsDiv) {
                secondsDiv.classList.remove('animate');
            }
            
            

            // setTimeout(() => {
            //     setDisplaySeconds(seconds);
            //     setDisplayPrevSeconds(_prevSeconds);
            // }, 100);

        };
      
        updateTimer(); //Prvi put da se pokrene
        const interval = setInterval(updateTimer, 1000);
      
        
        return () => clearInterval(interval);
      }, []);

    //   const { days, hours, minutes, seconds, expired } = timeLeft;
    //   const { prevDays, prevHours, prevMinutes, prevSeconds } = prevDates;

      const format = (num: number) => (num < 10 ? `0${num}` : num.toString());

return (
        <>
        {/* <div className="counter">
            <div className="counter-item">
                <div className={'countnum'} id="blockDays" ref={daysRef}> */}
                    {/* <div className="countnum-backtop">{expired ? "00" : format(prevDays)}</div>
                    <div className="countnum-backbottom">{expired ? "00" : format(prevDays)}</div>
                    <div className="countnum-top">{expired ? "00" : format(days)}</div>
                    <div className="countnum-bottom">{expired ? "00" : format(days)}</div>
                    <div className="countnum-line"></div> */}
                {/* </div>
                <div className="counter-title">Dana</div>
            </div>
            <div className="counter-item">
                <div className="countnum" id="blockHours" ref={hoursRef}> */}
                    {/* <div className="countnum-backtop">{expired ? "00" : format(prevHours)}</div>
                    <div className="countnum-backbottom">{expired ? "00" : format(prevHours)}</div>
                    <div className="countnum-top">{expired ? "00" : format(hours)}</div>
                    <div className="countnum-bottom">{expired ? "00" : format(hours)}</div>
                    <div className="countnum-line"></div> */}
                {/* </div>
                <div className="counter-title">Sati</div>
            </div>
            <div className="counter-item">
                <div className="countnum" id="blockMinutes" ref={minutesRef}> */}
                    {/* <div className="countnum-backtop">{expired ? "00" : format(prevMinutes)}</div>
                    <div className="countnum-backbottom">{expired ? "00" : format(prevMinutes)}</div>
                    <div className="countnum-top">{expired ? "00" : format(minutes)}</div>
                    <div className="countnum-bottom">{expired ? "00" : format(minutes)}</div>
                    <div className="countnum-line"></div> */}
                {/* </div>
                <div className="counter-title">Min</div>
            </div>
            <div className="counter-item">
                <div className="countnum animate" id="blockSeconds" ref={secondsRef}> */}
                    {/* <div className="countnum-backtop">{expired ? "00" : format(prevSeconds)}</div>
                    <div className="countnum-backbottom">{expired ? "00" : format(prevSeconds)}</div>
                    <div className="countnum-top">{expired ? "00" : format(seconds)}</div>
                    <div className="countnum-bottom">{expired ? "00" : format(seconds)}</div>
                    <div className="countnum-line"></div> */}
                {/* </div>
                <div className="counter-title">Sek</div>
            </div>
        </div> */}
        {isExpiredState && (
            <div className='counter-error'>
                <b>PROJEKAT JE U TOKU!</b>
                <br />
                <b>VIDIMO SE NA RADIONICAMA!</b>
            </div>
        )}
        {/* {!expired.current && (
            <div className='counter-message'><b>DO POČETKA PROJEKTA!</b></div>
        )} */}
        </>
    )
}

export default TimerComponent;